import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { Component, input, Input, OnChanges, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { CreatePersonPageWorkplaceTableStore } from './create-person-page-workplace-table.store';
import { FolderWorkplaceGridItemObject } from '@libs/types/src/services/object-type/folder-workplace.object';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { ConfirmBuilder } from '../../../../../shared/service/confirm.builder';
import { EditWorkplaceModalComponent } from '../edit-workplace-modal/edit-workplace-modal.component';
import { FilterInput } from '@it2go/data-grid';
import { dateFromColumn, dateToColumn } from '../../../../../shared/components/kit/table/table.fields';
import { CardTableComponent } from '../../../../../shared/components/kit/table/card-table.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-create-person-page-workplace-table',
    templateUrl: 'create-person-page-workplace-table.component.html',
    styleUrl: 'create-person-page-workplace-table.component.scss',
    providers: [CreatePersonPageWorkplaceTableStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        AsyncPipe,
        EditWorkplaceModalComponent,
    ],
})
export class CreatePersonPageWorkplaceTableComponent extends SubscriptionComponent implements OnChanges {

    protected readonly store = inject(CreatePersonPageWorkplaceTableStore);
    private readonly confirm = inject(ConfirmBuilder);

    @Input() folderId!: number;
    public canEdit = input(false);

    @ViewChild(EditWorkplaceModalComponent) editWorkplaceModal!: EditWorkplaceModalComponent;

    protected additionalFilter: FilterInput[][] | null = null;

    protected columns = [
        { name: 'name', sortable: true },
        dateFromColumn,
        dateToColumn,
    ];

    constructor() {
        super();
        this.store.registerSuccessMessage('unassignWorkplaceFromFolder', 'workplace.message.deleted');
        this.store.refreshGrid(
            'getFolderWorkplaces',
            'unassignWorkplaceFromFolder',
            'updateFolderWorkplace',
            'createFolderWorkplace',
        );
    }

    public ngOnChanges(): void {
        if (this.folderId) {
            this.additionalFilter = FilterBuilder.filter({ folderId: this.folderId }).filter || null;
            this.store.api.getFolderWorkplaces(FilterBuilder.filter({ folderId: this.folderId }));
        }
    }

    protected deleteWorkplace(item: any): void {
        if (item.item.workplaceDeleted) return;

        this.confirm.confirmDelete(
            () => this.store.api.unassignWorkplaceFromFolder({ id: item.item.id }),
            item,
        );
    }

    protected editWorkplace(item: FolderWorkplaceGridItemObject | null = null): void {
        if (item?.workplaceDeleted) return;

        this.editWorkplaceModal.editWorkplace(item);
    }

}
